/**
 * @generated SignedSource<<435ec6e3648eea9642eecd6b274b907f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DefaultTab_container$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TabWithMenu_container">;
  readonly " $fragmentType": "DefaultTab_container";
};
export type DefaultTab_container$key = {
  readonly " $data"?: DefaultTab_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"DefaultTab_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "DefaultTab_container",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabWithMenu_container"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "f01c95b8f6d1cd80c4ac15d2546c116d";

export default node;
